import React, { useContext, useEffect, useRef, useState } from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import Screen from '../../components/screen';
import SplashWait from '../../components/splash-wait';
import { AppContext } from '../../contexts/app-context';
import GlobalStyles from '../../global-styles';
import {
  checkUserAuthenticated, generateUUID, goToRoutePage, setWindowTitle, uploadStatusBatchFile
} from '../../utils/helper';
import { ExpandMoreIcon } from '../../utils/icons';
import {
  Accordion, AccordionDetails, AccordionSummary, Alert, AlertTitle, Box, Breadcrumbs, Button,
  Grid, LinearProgress, Link, Paper, Typography
} from '../../utils/material-ui-core';

const errorColumnNames = [
  { fileColumnName: "", columnName: "data", replaceName: "Source File Format" },
  {
    fileColumnName: "",
    columnName: "COMPANY_CODE",
    replaceName: "Company Code",
  },
  {
    fileColumnName: "",
    columnName: "PROGRAM_CODE",
    replaceName: "Program Code",
  },
  {
    fileColumnName: "",
    columnName: "ACCOUNT_NBR",
    replaceName: "Account Number",
  },
  { fileColumnName: "", columnName: "CHANGE_TYPE", replaceName: "Change Type" },
  {
    fileColumnName: "",
    columnName: "EFFECTIVE_DATE",
    replaceName: "Effective Date",
  },
  {
    fileColumnName: "",
    columnName: "USER_DEFINED_FIELD_1",
    replaceName: "User Defined Field 1",
  },
  {
    fileColumnName: "",
    columnName: "USER_DEFINED_FIELD_2",
    replaceName: "User Defined Field 2",
  },
  {
    fileColumnName: "",
    columnName: "USER_DEFINED_FIELD_3",
    replaceName: "User Defined Field 3",
  },
  {
    fileColumnName: "",
    columnName: "USER_DEFINED_FIELD_4",
    replaceName: "User Defined Field 4",
  },
  {
    fileColumnName: "",
    columnName: "USER_DEFINED_FIELD_5",
    replaceName: "User Defined Field 5",
  },
];

const BatchStatus = () => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  const { isUserAuthenticated } = useContext(AppContext);

  const formReference = useRef(null) as any;

  const [loading, setLoading] = useState<boolean>(true);
  const [fileLoaded, setFileLoaded] = useState<boolean>(false);
  const [processing, setProccessing] = useState<boolean>(false);
  const [uploadFileName, setUploadFileName] = useState<string>("");
  const [apiResponseErrorObject, setApiResponseErrorObject] = useState<ApiResponseErrorObject[]>([]);

  const downloadSampleFile = () => {
    const element = document.createElement("a");
    const file = new Blob(["COMPANY_CODE,PROGRAM_CODE,ACCOUNT_NBR,CHANGE_TYPE,EFFECTIVE_DATE,USER_DEFINED_FIELD_1,USER_DEFINED_FIELD_2,USER_DEFINED_FIELD_3,USER_DEFINED_FIELD_4,USER_DEFINED_FIELD_5"], {
      type: "text/csv;charset=utf-8;",
    });
    element.href = URL.createObjectURL(file);
    element.download = "File" + generateUUID() + ".csv";
    document.body.appendChild(element);
    element.click();
  };

  const handleUploadFileChange = async (event) => {
    setProccessing(true);
    setFileLoaded(true);

    setUploadFileName(event.target.files[0].name);
    const apiResponse = await uploadStatusBatchFile(event.target.files[0]);
    displayErrorMessage(apiResponse.errorObject);
    setProccessing(false);
  };

  const renameErrorTitle = (title: string) => {
    let title2: string = title;
    if (title === "header") {
      title2 = "Source File";
    } else if (title === "data") {
      title2 = "Source File";
    } else {
      title2 = title.replace("[", "").replace("]", "").replace("items", "item").replace("item", "Row ");
    }
    return title2;
  };

  const renameErrorSubTitle = (rowId: string, title: string) => {
    let title2: string = title.toLowerCase();
    title2 = title2.replaceAll(rowId.toLowerCase() + ".", "");
    title2 = title2.replace(rowId.toLowerCase(), "");
    title2 = title2.replaceAll(".", " ").toUpperCase();
    return title2;
  };

  const displayErrorMessage = (errorObject) => {
    const errorMessageList: ApiResponseErrorObject[] = [];
    const errorRowIds: string[] = [];

    errorObject.map((error) => {
      try {
        const errobj = error.title.split(".");
        if (errobj.length >= 1) {
          if (errorRowIds.join(",").indexOf(errobj[0]) < 0) {
            errorRowIds.push(errobj[0]);
          }
        }
      } catch (e) { }
      return true;
    });

    errorRowIds.map((rowId) => {
      const errorMessage: ApiResponseErrorObject = {
        title: rowId,
        message: [],
      };

      errorObject.map((error) => {
        if (error.title.indexOf(rowId) >= 0) {
          let columnName = renameErrorSubTitle(rowId, error.title);
          const temperrorColumnNames = errorColumnNames.filter((x) => {
            return x.columnName === columnName;
          });

          if (temperrorColumnNames.length === 1) {
            columnName = temperrorColumnNames[0].replaceName;
          }

          //errorMessage.message.push({ columnName: columnName, message: error.message });
          errorMessage.message.push({
            columnName: columnName,
            message: error.message.join(", "),
          });
        }
        return true;
      });
      errorMessageList.push(errorMessage);
      return true;
    });

    setApiResponseErrorObject(errorMessageList);
  };

  const reset = () => {
    formReference.current.value = "";
    setFileLoaded(false);
    setApiResponseErrorObject([]);
    setUploadFileName("");
    setProccessing(false);
  };

  useEffect(() => {
    setWindowTitle("Batch Enroll");
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const initializePage = async () => {
      checkUserAuthenticated(isUserAuthenticated);
      if (isUserAuthenticated) {
        setLoading(false);
        setProccessing(false);
      }
    };
    initializePage();
  }, [isUserAuthenticated]);

  return (
    <React.Fragment>
      {loading ? (
        <SplashWait />
      ) : (
        <Screen>
          <Box className={pageStyles.root}>
            <Grid container spacing={3} className={globalStyles.bottomSpacer}>
              <Grid item xs={12}>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link color="inherit" onClick={() => goToRoutePage("home")} className={globalStyles.link}>
                    Home
                  </Link>
                  <Typography color="textPrimary">Batch</Typography>
                  <Typography color="textPrimary">Status</Typography>
                </Breadcrumbs>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    {!processing && uploadFileName !== "" ? (
                      <Alert severity={"error"}>
                        <AlertTitle>Please fix the following errors and try again.</AlertTitle>
                      </Alert>
                    ) : null}

                    <Paper elevation={0} className={pageStyles.paperContainer}>
                      {!fileLoaded ? (
                        <>
                          <Alert severity={"info"}>
                            <AlertTitle>Instructions</AlertTitle>

                            <Box p={1}>Status file in either CSV or TXT (tilde delimited); or Excel format.</Box>
                            <Box p={1}>Limited to files with less than or equal to 250 records.</Box>
                            <Box p={1}>Delete all empty rows</Box>
                            <Box p={1}>Records must all be from the same client company / program.</Box>
                            <Box p={1}>
                              <Button onClick={() => downloadSampleFile()} color="default" variant="contained" component="span">
                                Download Template File
                              </Button>
                            </Box>
                          </Alert>
                          <Box p={6}>&nbsp;</Box>
                        </>
                      ) : null}

                      <label htmlFor="upload-enrollment-file">
                        <input ref={formReference} accept=".csv,.xlsx,.xls" style={{ display: "none" }} id="upload-enrollment-file" name="upload-enrollment-file" type="file" onChange={handleUploadFileChange} />

                        {!processing && !fileLoaded ? (
                          <Box>
                            <Box p={1} display="flex" justifyContent="center" alignContent="center">
                              <Typography variant="body1" component="span">
                                {" "}
                                Select status file to process
                              </Typography>
                            </Box>

                            <Box p={3} display="flex" justifyContent="center" alignContent="center">
                              <Button color="secondary" variant="contained" component="span">
                                Browse
                              </Button>
                            </Box>
                          </Box>
                        ) : null}
                      </label>

                      {processing ? <LinearProgress color="secondary" /> : null}

                      {!processing && uploadFileName !== "" ? <Box p={3}>Enrollment File Name : &nbsp; {uploadFileName}</Box> : null}

                      {!processing && fileLoaded ? (
                        <Box p={3} display="flex" justifyContent="center">
                          <Button color="secondary" variant="contained" component="span" onClick={reset}>
                            Reset
                          </Button>
                        </Box>
                      ) : null}
                    </Paper>
                  </Grid>
                </Grid>

                <Grid container spacing={3} className={globalStyles.bottomSpacer}>
                  {apiResponseErrorObject.length > 0 ? (
                    <Grid item xs={12}>
                      <Box p={1}>&nbsp;</Box>

                      {apiResponseErrorObject.map((error, index) => {
                        return (
                          <Accordion key={index} className={pageStyles.accordionContainer}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                              <Typography className={pageStyles.heading}> {renameErrorTitle(error.title)}</Typography>
                              <Typography className={pageStyles.secondaryHeading}>
                                {error.message.map((message, index2) => {
                                  return (
                                    <Typography variant="caption" component="span" key={index2}>
                                      {index2 >= 1 ? ", " : ""}
                                      {message.columnName}
                                    </Typography>
                                  );
                                })}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container>
                                {error.message.map((message, index2) => {
                                  return (
                                    <Grid item xs={12} key={index2}>
                                      <Typography className={pageStyles.subHeading}>
                                        <small>{message.columnName}</small>
                                      </Typography>
                                      <Box p={1}>
                                        <Typography variant="body1" component="div">
                                          <small>{message.message}&nbsp;</small>
                                        </Typography>
                                      </Box>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })}
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Screen>
      )}
    </React.Fragment>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 0,
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.error.main,
    },
    subHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    accordionContainer: {
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[50],
      borderLeftWidth: 5,
      borderLeftColor: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.grey[700],
      borderLeftStyle: "solid",
    },
    paperContainer: {
      backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[50],
      borderWidth: 1,
      borderColor: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.grey[200],
      borderStyle: "solid",
    },
  })
);

export default BatchStatus;
